import React from 'react'

import logIn from '../../actions/logIn'
import FirebaseAuth from '../misc/FirebaseAuth'
import PageLoading from '../misc/PageLoading'
import Error from '../misc/Error'
import AppHeader from '../misc/AppHeader'
import CopyrightInfo from '../misc/CopyrightInfo'
import Profile from './Profile'
// import Notifications from './Notifications'
import Subscription from './Subscription'
import {
  Page,
  Footer,
} from '../../styles/layout'
import {
  Button,
} from '../../styles/buttons'

const Account = ({history}) => (
  <Page>
    <AppHeader showBackButton />

    <FirebaseAuth>
      { ({isLoading, error, auth}) => {

        if (isLoading) {
          return <PageLoading />
        }

        if (error) {
          return <Error error={error} />
        }

        if (!auth) {
          return <div>
            <p>Log in to see your account</p>
            <Button onClick={logIn}>Log in</Button>
          </div>
        }

        return <div>
          <Profile auth={auth} history={history} />
          <hr />
          {/* <Notifications auth={auth} />
          <hr /> */}
          <Subscription auth={auth} />

          <Footer>
            <CopyrightInfo />
          </Footer>
        </div>

      }}
    </FirebaseAuth>
  </Page>
)

export default Account



// WEBPACK FOOTER //
// ./src/views/account/index.js